import { WhatPeopleSay } from '@/components/Testimonals/WhatPeopleSay';
import React from 'react';

export default function Testimonals() {
  return (
    <div className="mt-[6rem] flex w-full flex-wrap justify-center py-[4rem] font-inter">
      <div className="flex w-full max-w-[114rem] flex-row flex-wrap items-stretch justify-center gap-x-[1rem] gap-y-[3rem] px-[2rem]">
        <div className="flex w-full flex-wrap items-start gap-[2rem]">
          <div className="mt-[4rem] flex w-full flex-col items-center text-center">
            <h1 className="mb-[2rem] w-full text-center text-[1.8rem] font-[500] leading-[1.8rem] text-[#0EC9AC]">
              What People Say
            </h1>
            <h1 className="text-[3.6rem] font-[600] leading-[4.65rem] text-white">
              Client Testimonials
            </h1>
          </div>

          <div className="mt-[2rem] flex w-full flex-row flex-wrap justify-between md:mt-[4rem]">
            {/* <div className="w-full">
              {faqsLeft.map((faq, index) => (
                <FAQItem key={index} faq={faq} />
              ))}
            </div>
            <div className="w-full">
              {faqsRight.map((faq, index) => (
                <FAQItem key={index} faq={faq} />
              ))}
            </div> */}
            <WhatPeopleSay />
          </div>
        </div>
      </div>
    </div>
  );
}
